import React from 'react'

import withRouter from 'Pods/Shared/withRouter'

import CreateProjectForm from './Components/CreateProjectForm'

class ProjectsEditForm extends React.Component {
  render() {
    return (
      <div className="container-fixed">
        <CreateProjectForm
          scope="edit"
          id={this.props.match && this.props.match.params.id}
        />
      </div>
    )
  }
}

export default withRouter(ProjectsEditForm)
